import { render, staticRenderFns } from "./accountCreation.component.vue?vue&type=template&id=71f7ec0d"
import script from "./accountCreation.component.ts?vue&type=script&lang=ts&external"
export * from "./accountCreation.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports